/* Neko Toys — Homepage tabs section behavior:
   - Tab switching (Selling / Upcoming)
   - Swiper.js init for each product card (main carousel + thumbnail strip)
   - Computes header height into --neko-header-height for sticky tab bar offset
   Loaded as defer from sections/neko-homepage-tabs.liquid. */
(function () {
  'use strict';

  // -------------------- Header height tracking --------------------
  // Sticky tab bar needs to sit BELOW the sticky header. Header height
  // varies by viewport, so compute it dynamically and expose as a CSS var.
  function syncHeaderHeight() {
    const header = document.querySelector('.shopify-section.neko-header-section');
    if (!header) return;
    document.documentElement.style.setProperty(
      '--neko-header-height',
      header.offsetHeight + 'px'
    );
  }
  syncHeaderHeight();
  window.addEventListener('resize', syncHeaderHeight);
  // Also resync after fonts/images load (header height can shift slightly)
  window.addEventListener('load', syncHeaderHeight);

  // -------------------- Tab switching --------------------
  document.querySelectorAll('.neko-tabbar__btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const target = btn.dataset.tabTarget;
      document.querySelectorAll('.neko-tabbar__btn').forEach(function (b) {
        const isActive = b.dataset.tabTarget === target;
        b.classList.toggle('is-active', isActive);
        b.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      document.querySelectorAll('.neko-tab-content').forEach(function (panel) {
        const isTarget = panel.dataset.tabId === target;
        panel.classList.toggle('is-active', isTarget);
        panel.toggleAttribute('hidden', !isTarget);
      });
    });
  });

  // -------------------- Init Swiper carousels --------------------
  function initSwipers() {
    if (!window.Swiper) {
      // Swiper.js still loading — retry shortly
      return setTimeout(initSwipers, 50);
    }
    document.querySelectorAll('.neko-product-card:not([data-feed-card])').forEach(function (card) {
      // Skip cards already initialized (in case of section re-render)
      if (card.dataset.swiperInit === 'true') return;

      const mainEl = card.querySelector('.neko-product-card__main');
      const thumbsEl = card.querySelector('.neko-product-card__thumbs');
      if (!mainEl) return;

      // Some cards have only 1 image — no thumbs strip rendered, skip thumbs swiper
      let thumbs = null;
      if (thumbsEl) {
        const perView = parseInt(thumbsEl.dataset.thumbsPerView, 10) || 5;
        thumbs = new window.Swiper(thumbsEl, {
          slidesPerView: perView,
          spaceBetween: 8,
          freeMode: true,
          watchSlidesProgress: true,
        });
      }

      // Read autoplay settings from the parent .neko-homepage section.
      // Skip autoplay/loop for single-image swipers (Swiper warns and breaks
      // when looping with <2 slides).
      const homepage = card.closest('.neko-homepage');
      const slideCount = mainEl.querySelectorAll('.swiper-slide').length;
      const autoplayOn = homepage && homepage.dataset.autoplay === 'true' && slideCount > 1;
      const autoplayDelay = homepage ? parseInt(homepage.dataset.autoplayDelay, 10) : 4000;

      new window.Swiper(mainEl, {
        spaceBetween: 0,
        loop: autoplayOn,
        thumbs: thumbs ? { swiper: thumbs } : undefined,
        autoplay: autoplayOn ? {
          delay: autoplayDelay,
          disableOnInteraction: false,  // keep playing after user swipes
          pauseOnMouseEnter: true,      // pause on hover (desktop only — touch devices ignore)
        } : false,
      });

      card.dataset.swiperInit = 'true';
    });
  }
  initSwipers();
})();
